import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BackButton from '../../../../components/UI/BackButton';
import { translate, isNullOrEmpty } from '../../../../utils/util';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import * as actionInventory from '../../../../actions/inventoryAction';
import { Button, ScannerCode, Input } from '../../../../components/UI/ComponentsUI';

const GeneralInventoryFilterByLotItem = (props) => {
    const [filter, setFilter] = useState({ qrCode: "", lotItemCode: "" });

    const applyFilter = () => {
        if (!isNullOrEmpty(filter.lotItemCode) || !isNullOrEmpty(filter.qrCode)) {
            props.filter.lotItemNumber = filter.lotItemCode;
            props.filter.validationCode = filter.qrCode;
            props.filter.lockedBy = undefined;
            props.filter.startedBy = undefined;
            props.setFilter(props.filter);
            // Redirect para tela de Lots
            props.history.push({
                pathname: '../lotItemsClosed',
                state: { byFilter: true, byFilterLotItem: true }
            });
        }
    };

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('inventory', 'inventory')}
                    </div>
                    <div className="subtitle">
                        | <i className="mdi mdi-alpha-g-circle-outline" />
                        {props.filter.typeInventory === 'G' ? translate('menu.general', 'inventory') : translate('menu.rotative', 'inventory')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">filter_list</i>
                        {translate('general.menu.lotItem', 'inventory')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="input-field no-padding col s5">
                        <Input
                            id="lotItemCode"
                            name="lotItemCode"
                            placeholder='Nota'
                            defaultValue={filter.lotItemCode}
                            type="number"
                            onChange={onChange}
                            maxLength="20"
                        />
                    </div>
                    <div className="input-field no-padding col s6">
                        <ScannerCode onScanner={(value) => {
                            filter.qrCode = value
                            setFilter({ ...filter })
                        }} />
                        <Input
                            label="QrCode"
                            id="qrCode"
                            name="qrCode"
                            type="text"
                            defaultValue={filter.qrCode}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <Button full="true" onClick={() => applyFilter()} text={translate('apply', 'general')} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filter) => {
            dispatch(actionInventory.setFilterGeneral(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GeneralInventoryFilterByLotItem)));
